<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-14 10:32:27
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-20 09:33:21
-->
<template>
  <ux-form
    class="bind-access"
    ref="form"
    :data="formData"
    :rules="rules"
    data-automation="bindAccess"
    :colon="true"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.bindApply.appId')" prop="app_id">
      <ux-select
        v-model="formData.app_id"
        :options="list"
        :props="{ label: 'name', value: 'id' }"
        :isDisabled="appData.app_id ? true : false"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.bindFlowApp.rate')" prop="rate">
      <ux-input
        v-model="formData.rate"
        :placeholder="$t('HT.bindFlowApp.rate.placeholder', { max: this.data.rate })"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    appData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      formData: {
        app_id: this.appData.app_id, // 授权应用
        id: this.appData.id, //
        rate: this.appData.rate // 流量限制
      },
      rules: this.$rul.bindApply(this.data.rate)
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
